import React from 'react';
import { NamesDivStyle, OrderedTextStyle, TextStyle } from './LegacyStyles';
import { LegacyOrder, LegacyOrderOwner } from '../../types';

interface Props {
  legacyOrder: LegacyOrder;
}

const NamesSlideout = (props: Props) => {
  return (
    <React.Fragment>
      <NamesDivStyle>
        <div
          style={{
            marginTop: 30,
            marginBottom: 30,
            display: 'flex',
            alignContent: 'center',
          }}
        >
          <OrderedTextStyle style={{ marginRight: 8 }}>Names</OrderedTextStyle>
        </div>

        {props.legacyOrder.owners.map((o: LegacyOrderOwner) => {
          return (
            <div style={{ marginBottom: 24 }}>
              <TextStyle>{o.name}</TextStyle>
              <br />
            </div>
          );
        })}
      </NamesDivStyle>
    </React.Fragment>
  );
};
export default NamesSlideout;
